export default __webpack_public_path__ + "7a50e5215254f28376b50719cc22dfaf.svg";